<template>
  <v-row align="center">
    <v-col>
      <v-text-field
        id="search_field"
        v-model.trim="searchVal"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        clearable
        outlined
        hide-details
        dense
      >
        <template v-slot:prepend-inner>
          <template v-if="searchKeyOptions.length > 0">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  label
                  small
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ selectedSearchOption.name }}
                  <v-icon right>
                    mdi-menu-down
                  </v-icon>
                </v-chip>
              </template>
              <v-list 
                class="py-0" 
                dense
              >
                <!-- {{ searchKeyOptions }} -->
                <div
                  v-for="searchKeyOption in searchKeyOptions"
                  :key="`search-fields--${searchKeyOption.id}`"
                >
                  <v-list-item @click="changeSearchOption(searchKeyOption)">
                    <v-list-item-title>{{ searchKeyOption.name }}</v-list-item-title>
                  </v-list-item>
                  <v-divider />
                </div>
              </v-list>
            </v-menu>
          </template>
        </template>
      </v-text-field>
    </v-col>
    <v-col cols="auto">
      <status-filter
        :status="statusVal"
        @change="onChangeStatus"
      />
    </v-col>
  </v-row>
</template>

<script>
import StatusFilter from "@/components/utils/StatusFilter";

export default {
  name: "SearchField",
  components: {
    StatusFilter
  },
  props: {
    searchText: {
      type: String,
      default: ""
    },
    status: {
      type: String,
      required: true
    },
    searchKeyOptions: {
      type: Array,
      default: () => []
    },
    searchKey: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selectedSearchOption: {
        id: "",
        name: ""
      }
    };
  },
  computed: {
    searchVal: {
      get() {
        return this.searchText;
      },
      set(val) {
        this.$emit("search", val);
      }
    },
    statusVal() {
      return this.status;
    }
  },
  created() {
    this.setSelectedSearchOption(this.searchKey);
  },
  methods: {
    onChangeStatus(status) {
      this.$emit("statusChange", status);
    },
    changeSearchOption(searchKeyOption) {
      this.selectedSearchOption = searchKeyOption;
      this.$emit("onSearchKeyChange", searchKeyOption.id);
    },
    setSelectedSearchOption(id) {
      if (this.searchKeyOptions.length !== 0) {
        let match = this.searchKeyOptions.find(o => o.id === id);
        if (!match) {
          match = this.searchKeyOptions[0];
        }
        this.changeSearchOption(match);
      }
    }
  }
};
</script>